import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getNotifications, readNotification } from "api/notifications.api";

// send role as params i.e:- view-notifications/1; 1 for teacher and 2 for customer
export const useNotifications = (role, token) => {
  let actualRole = role === 1 ? 2 : 1;

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["getNotifications", actualRole],
    queryFn: () => getNotifications(actualRole),
    enabled: !!token,
  });

  return {
    data: data?.data,
    isError,
    isLoading,
    fetch: refetch,
  };
};

export const useReadNotification = (role) => {
  const queryClient = useQueryClient();
  let actualRole = role === 1 ? 2 : 1;

  return useMutation({
    mutationFn: async (notificationId, status = "read") => {
      return readNotification(Number.parseInt(notificationId), status);
    },
    onSuccess: () => {
      const queryKey = ["getNotifications", actualRole];
      queryClient.invalidateQueries({ queryKey });
    },
    onError: (error: any) => {
      console.error(
        error.response?.data?.message || "Failed to update notification"
      );
    },
  });
};
